import { topicPartQuestionRepository } from "../../../providers/repositories/topicPartQuestionRepository";
import { TopicPartQuestion } from "../entities/TopicPartQuestion";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const updateTopicPartQuestionOrderUseCase = {
    async exec(list: TopicPartQuestion[]): Promise<boolean> {
        try {
            await topicPartQuestionRepository.updateOrder(list);
            toast.success(t('action.updateSuccess'));
            return true;
        } catch (error) {
            Logger.error('updateTopicPartQuestionOrderUseCase', error);
            toast.error(t('action.updateError'));
        }
        return false;
    },
}; 